import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import PurchaseBulkOrder from "./PurchaseBulkOrder"
import { selectors as purchaseOrderSelectors} from "redux/PurchaseOrder";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getBulkFleetHistoryTimeLine, getBulkOrderDescriptionDropdown, getBulkOrderExcelData, getBulkOrderFleetHeader, getBulkOrderFleetPurchaseDetail, getBulkOrderHeader, getBulkOrderPurchaseOrder, getBulkOrderVendorDetails, saveCancelBulkOrder, setBulkOrderExcelData, setBulkOrderFleetHeader, setBulkOrderHeader, setBulkOrderVendorDetails, setCancelBulkOrder } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import { base64ToArrayBuffer, saveByteArray } from "utils";
import { operations as purchaseOrderOperations } from "redux/PurchaseOrder";
import { CONSTANTS } from "client/utils/constants";
import userProfileSelectors from "redux/UserProfile/selectors" 
import { saveAssignedToForAllItem, setAssignedToForAllItem, setOpenAccordionList } from "Store/Component/FleetManagement/FleetManagementAction";
import { getChangeLogs } from "redux/PurchaseOrder/action";
import RejectedBee from "../../../assets/images/PenndingApproval/Rejected Bee.png";
import navOperations from "redux/Navigation/operations";


const PurchaseBulkOrderContainer = (props: any) => {
  const {  
    setSelectedKey,
    tabSwitchClicked,
    setTabSwitchClicked,
    tab
  } = props
    const dispatch = useDispatch();
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const navigate = useNavigate();
  const {
    bulkOrderHeaderDetails,
    bulkOrderFleetDetails,
    bulkOrderDescriptionDropdownList,
    bulkOrderExcelData,
    taskHeaderDetails,
    taskItemDetails,
    bulkFleetHistoryTimeLine,
    assignTo,
    getUserDetails,
    assignedForAllItem,
    openAccordionList,
    userDetails,
    cancelBulkOrder,
    headerNav
     }: any = useSelector((state: any) => ({
      bulkOrderHeaderDetails: state.PurchaseBulkOrderReducer.bulkOrderHeaderDetails,
      bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
      bulkOrderDescriptionDropdownList: state.PurchaseBulkOrderReducer.bulkOrderDescriptionDropdownList,
      bulkOrderExcelData: state.PurchaseBulkOrderReducer.bulkOrderExcelData,
      taskHeaderDetails: state.PurchaseBulkOrderReducer.taskHeaderDetails,
      taskItemDetails: state.PurchaseBulkOrderReducer.taskItemDetails,
      bulkFleetHistoryTimeLine: state.PurchaseBulkOrderReducer.bulkFleetHistoryTimeLine,
      assignTo: state.PurchaseOrder.assignTo,
      getUserDetails: userProfileSelectors.getUserDetails(state),
      assignedForAllItem: state.fleetAdminTaskReducer?.assignedForAllItem,
      openAccordionList: state?.fleetAdminTaskReducer?.openAccordionList,
      userDetails: userProfileSelectors.getUserDetails(state),
      cancelBulkOrder: state.PurchaseBulkOrderReducer.cancelBulkOrder,
      headerNav: state.nav.headerNav,

    }))
  
    const dispatchAssignToDropdown = purchaseOrderOperations.dispatchAssignToDropdown(dispatch);
    const [isOrderOpened, setIsOrderOpened] = useState<any>(false);
    const [isCancelRequestClicked, setIsCancelRequestClicked] = useState<any>(false);
    
    const [isAssignedToChecked, setIsAssignedToChecked] = useState<any>(false);
    const [assignedToForAllValue, setAssignedToForAllValue] = useState<any>("");

  useEffect(() => {
    if (tabSwitchClicked) {
      setSelectedKey(tab);
      setTabSwitchClicked(false)
    }
  }, [tabSwitchClicked])

  useEffect(()=>{
    if(assignedForAllItem?.response && assignedForAllItem?.payload?.fleetItemIds?.length > 0){
      const fleetIds = assignedForAllItem?.payload?.fleetItemIds
      const filteredArray = fleetIds?.filter((value:any) => openAccordionList?.includes(value));
      filteredArray?.map((item:any)=>{
          dispatch(getChangeLogs(item))
      })
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        item?.taskHeaderDetails?.map((childItem:any)=>{
          if(filteredArray?.includes(childItem?.fleetDetailId))
            childItem.assignedTo = assignedForAllItem?.payload?.assignedTo
        })
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    }
  },[assignedForAllItem])
    
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
        popupOutlinebtnOnclick: () => { },
        popupPrimarybtnOnclick: () => { }
    });
      
    let { id } = useParams();
    useEffect(()=>{
      if (id != undefined) {
        setIsOrderOpened(true)
        dispatch(setBulkOrderFleetHeader(null))
        dispatch(setBulkOrderVendorDetails(null))
        dispatch(getBulkOrderHeader(id))
        dispatch(getBulkOrderFleetHeader(id))
        dispatch(getBulkFleetHistoryTimeLine(id))
        dispatch(getBulkOrderVendorDetails(id))
        dispatch(setAssignedToForAllItem([]))
        dispatch(setOpenAccordionList([]))
      }
    },[id])

    useEffect(()=>{
      dispatchAssignToDropdown();
    },[])
    useEffect(()=>{
      setIsAssignedToChecked(bulkOrderHeaderDetails?.isLockedBy)
      setAssignedToForAllValue(bulkOrderHeaderDetails?.lockedBy)
    },[bulkOrderHeaderDetails?.isLockedBy, bulkOrderHeaderDetails?.lockedBy])
   
    useEffect(() => {
        if(bulkOrderFleetDetails?.length && isOrderOpened){
          setIsOrderOpened(false)
          const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
          bulkOrderFleetDetailsTemp?.map((item?: any) => {
            item.isNonConsolidatedPOCreated = false
            let count = 0
            item?.purchaseDetails?.items?.map((fleetPOItem?: any) => {
              if ([CONSTANTS.PO_STATUS.IN_PROGRESS, CONSTANTS.PO_STATUS.COMPLETE].includes(fleetPOItem?.status)) {
                count = count + 1
              }
            })
            if (count > 0) {
              item.isPOCreated = true
            } else {
              item.isPOCreated = false
            }
            if (item?.fleetRequests?.length == count) {
              item.isPoPartiallyCreated = false
            } else {
              item.isPoPartiallyCreated = true
            }
          })
          dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        }
    },[bulkOrderFleetDetails])

    useEffect(() => {
      if(bulkOrderExcelData?.length){
          const bytes = base64ToArrayBuffer(bulkOrderExcelData);
          saveByteArray("BulkOrderFleetProcessing", bytes, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          dispatch(setBulkOrderExcelData([]))
      }
    }, [bulkOrderExcelData])

    useEffect(() => {
      if (taskHeaderDetails) {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
          bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == taskHeaderDetails?.orderDetailId) {
              item.taskHeaderDetails = taskHeaderDetails?.data
            }
          })
          dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
      }
    }, [taskHeaderDetails])

    useEffect(() => {
      if (taskItemDetails) {
        const taskListTrackings = taskItemDetails?.data?.taskListTrackings;
        let stepId = taskListTrackings?.map((item:any)=>item.stepId).filter((item:any, i:any, ar:any) => ar.indexOf(item) === i)
        let taskListTrackingsTemp:any = []
        taskListTrackingsTemp = stepId?.map((item:any)=>{
          const list = taskListTrackings?.map((detailItem:any)=>
            {
              if(item == detailItem?.stepId){
                detailItem.isApplicable = !detailItem?.isApplicable
              return detailItem
              }
            }
          ).filter((childItem:any)=>childItem?.stepId == item)
          let stepTemp = taskListTrackings?.find((childItem:any)=>childItem?.stepId == item)
          return {step: stepTemp?.step,list}
        })
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
          bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == taskItemDetails?.orderDetailId) {
              item.taskHeaderDetails?.map((childItem: any)=>{
                if(childItem.fleetDetailId == taskItemDetails.fleetDetailId){
                  childItem.taskItemDetails = taskListTrackingsTemp
                  childItem.assignedTo = taskItemDetails?.data?.assignedTo
                  childItem.comment = taskItemDetails?.data?.comment
                  childItem.cancelComments = taskItemDetails?.data?.cancelComments
                }
              })
            }
          })
          dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
      }
    }, [taskItemDetails])

    useEffect(() => {
      if (bulkOrderDescriptionDropdownList?.data?.length > 0) {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
          bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == bulkOrderDescriptionDropdownList?.orderDetailId) {
              const dropdownList = bulkOrderDescriptionDropdownList.data?.map((value: any)=>({    
                ...value,
                label: value?.description,
                value: value?.assetModelId,
                key: value?.assetModelId,
                price : value?.price
              }))
              item.descriptionDropdownList = dropdownList;
            }
          })
          dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
      }
    }, [bulkOrderDescriptionDropdownList])

    useEffect(()=>{
      if(assignedForAllItem?.response){
        const bulkOrderHeaderDetailsTemp: any = bulkOrderHeaderDetails ? JSON.parse(JSON.stringify(bulkOrderHeaderDetails)) : []
        bulkOrderHeaderDetailsTemp.lockedBy = assignedForAllItem?.payload?.assignedTo
        bulkOrderHeaderDetailsTemp.isLockedBy = assignedForAllItem?.payload?.isAssignedToForAll
        dispatch(setBulkOrderHeader(bulkOrderHeaderDetailsTemp));
      }
    },[assignedForAllItem])

    useEffect(() => {
      if (cancelBulkOrder?.fleetDetailIds?.length > 0) {
        const bulkOrderHeaderDetailsTemp: any = bulkOrderHeaderDetails ? JSON.parse(JSON.stringify(bulkOrderHeaderDetails)) : {}
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        
        bulkOrderFleetDetailsTemp?.forEach((item: any) => {
          item?.taskHeaderDetails?.forEach((taskItem: any) => {
            if (cancelBulkOrder.fleetDetailIds.includes(taskItem.fleetDetailId)) {
              taskItem.fleetStatus = cancelBulkOrder.fleetStatus;
              taskItem.itemStatus = cancelBulkOrder.itemStatus;
              taskItem.orderStatus = cancelBulkOrder.orderStatus;
              taskItem.cancelComments = cancelBulkOrder.cancelComments;
            }
          });
          
          item?.fleetRequests?.forEach((fleetItem: any) => {
            if (cancelBulkOrder.fleetDetailIds.includes(fleetItem.fleetItemId)) {
              fleetItem.fleetStatus = cancelBulkOrder.fleetStatus;
              fleetItem.itemStatus = cancelBulkOrder.itemStatus;
            }
          });
        });
        
        bulkOrderHeaderDetailsTemp.orderStatus = cancelBulkOrder.orderStatus;
        
        dispatch(setBulkOrderHeader(bulkOrderHeaderDetailsTemp));
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp));
        dispatch(setCancelBulkOrder({}));

        // Show success popup
        if (isCancelRequestClicked) {
          setIsCancelRequestClicked(false);
          let decriptionTxt = (
            <div>
              <p>Order Cancelled Successfully</p>
            </div>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: RejectedBee,
            title: "CANCEL ORDER",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            isCommentboxVisible: false,
            isCommentBoxRequire: false,
            outlineBtnText: "Close",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclick: () => {
              setPopupcontent({ ...Popupcontent, isDialogVisible: false })
              navigate('/ordermanagement')
              dispatchNav(headerNav);
              dispatch(setCancelBulkOrder({}))
            },
            popupPrimarybtnOnclick: () => { }
          });
        }
      } else if (cancelBulkOrder && Object.keys(cancelBulkOrder).length > 0 && !cancelBulkOrder?.fleetDetailIds && isCancelRequestClicked) {
        // Show failure popup if response doesn't have fleetDetailIds (error case)
        setIsCancelRequestClicked(false);
        dispatch(setCancelBulkOrder({}));
        let decriptionTxt = (
          <div>
            <p>Order Cancellation Failed</p>
          </div>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: RejectedBee,
          title: "CANCEL ORDER",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          isCommentboxVisible: false,
          isCommentBoxRequire: false,
          outlineBtnText: "Close",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: () => {
            setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          },
          popupPrimarybtnOnclick: () => { }
        });
      }
    }, [cancelBulkOrder])

    const handleItemCancelClick = (e?: any, id?: any) => {
        e.preventDefault();
        let decriptionTxt = (
          <>
            <p>Are you sure you want to cancel this item?</p>
          </>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "Confirmation",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
            setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          },
          popupPrimarybtnOnclick: () => {
            setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          }
        });
      }
    
      const hideConfirmationDialog = useCallback(
        () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
        [Popupcontent]
      );

      const onChangeAccordian = (selectedItems:any) => {
        if(selectedItems?.length){
          const value =  selectedItems[selectedItems?.length-1];
          const result = value?.substring(16, value.length);
          const findorder = bulkOrderFleetDetails.find((item:any)=>item.orderDetailId == result)
          if(!findorder?.purchaseDetails?.requestDetailId) {
            dispatch(getBulkOrderFleetPurchaseDetail(result))
            dispatch(getBulkOrderDescriptionDropdown(result))
          }
          if((findorder?.stepNumber == 2)){
            dispatch(getBulkOrderVendorDetails(findorder?.orderDetailId))
          } else if((findorder?.stepNumber == 3)){
            dispatch(getBulkOrderPurchaseOrder(findorder?.orderDetailId))
          }
        }
      }

      const onAssignedToToggleChange = (e?: any) => {
        e.preventDefault();
        if (assignedToForAllValue?.length > 0) {
          const fleetItemIds:any = []
          bulkOrderFleetDetails.forEach((item:any) => {
              item.fleetRequests.forEach((childItem:any)=>{
                if(childItem.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && childItem.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE){
                  fleetItemIds.push(childItem.fleetItemId)
                }
              })   
          });
          let payload = {
              orderId: bulkOrderHeaderDetails?.orderRequestId,
              fleetItemIds: e.target.checked ? fleetItemIds : [],
              isAssignedToForAll: e.target.checked,
              assignedTo: assignedToForAllValue,
              savedBy: getUserDetails?.emailId
          }
          dispatch(saveAssignedToForAllItem(payload))
          setIsAssignedToChecked(e.target.checked)
        }else{
          setIsAssignedToChecked(e.target.checked)
        }
    }

    const onAssignedToDropdownChange = (e?: any, item?:any) => {
        setAssignedToForAllValue(item.value)
        const fleetItemIds:any = []
        bulkOrderFleetDetails.forEach((item:any) => {
            item.fleetRequests.forEach((childItem:any)=>{
              if(childItem.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && childItem.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE){
                fleetItemIds.push(childItem.fleetItemId)
              }
            })   
        });
        let payload = {
            orderId: bulkOrderHeaderDetails?.orderRequestId,
            fleetItemIds: fleetItemIds,
            isAssignedToForAll: true,
            assignedTo: item?.value,
            savedBy: getUserDetails?.emailId
        }
        dispatch(saveAssignedToForAllItem(payload))
    }

    const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  const handleBulkOrderCancel = (e?: any, fleetDetailId?: any) => {
          e.preventDefault();
          const decriptionTxt = (
            <div>
              <p>Are you sure you want to cancel the Order</p>
              <p>
                <b>LEADR Order # : </b>{id}
              </p>
            </div>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: RejectedBee,
            title: "CANCEL ORDER",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            isCommentboxVisible: true,
            isCommentBoxRequire: true,
            isSingleConfirmationBtn: false,
            popupOutlinebtnOnclick: () => {
              setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            },
            popupPrimarybtnOnclick: (item: any,
              comment: string,
              actionby: string,
              value: any) => {
              const payload = {
                  "orderRequestId": bulkOrderHeaderDetails?.orderRequestId,
                  "savedBy": userDetails?.emailId,
                  "comments": comment
              }
              setIsCancelRequestClicked(true);
              dispatch(saveCancelBulkOrder(payload))
              setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            }
          });
        }


    return(
        <PurchaseBulkOrder 
            Popupcontent={Popupcontent}
            hideConfirmationDialog={hideConfirmationDialog}
            onChangeAccordian={onChangeAccordian}
            bulkOrderHeaderDetails={bulkOrderHeaderDetails}
            bulkOrderFleetDetails={bulkOrderFleetDetails}
            bulkFleetHistoryTimeLine = {bulkFleetHistoryTimeLine}
            id = {id}
            assignTo = {assignTo}
            onAssignedToToggleChange = {onAssignedToToggleChange}
            onAssignedToDropdownChange = {onAssignedToDropdownChange}
            isAssignedToChecked = {isAssignedToChecked}
            getUserRoles={getUserRoles}
            assignedToForAllValue = {assignedToForAllValue}
            handleBulkOrderCancel = {handleBulkOrderCancel}
        />
    )
}

export default PurchaseBulkOrderContainer